// extracted by mini-css-extract-plugin
export default {"testSearch":"_3hPVFJfD5I-kYJcZOwJRZH","text-map":"_1uT-hzM0KQPi9iVCLCXsy9","col-lg-8":"X4E6ZCb2aY7QxvszFz7V_","col-lg-4":"AlB-cZY1drRFClK_MNtBz","root":"_3YiOfGf7EkcRL3sFpKIxIA"};